import React from 'react'
import Container from '../Container/Container'
import './Statistics.scss'

function Statistics() {
	return (
		<section className='statistics'>
			<Container>
				<div className='statistics__wrapper'>
					<ul className='statistics__list'>
						<li className='statistics__item'>
							<p className='statistics__numbers'>10+</p>
							<h1 className='statistics__heading'>Loyihalar</h1>
						</li>

						<li className='statistics__item'>
							<p className='statistics__numbers'>20+</p>
							<h1 className='statistics__heading'>To'liq vaqtli muhandislar</h1>
						</li>

						<li className='statistics__item'>
							<p className='statistics__numbers'>10+</p>
							<h1 className='statistics__heading'>korxonalar rag'batlantirildi</h1>
						</li>

						<li className='statistics__item'>
							<p className='statistics__numbers'>5+</p>
							<h1 className='statistics__heading'>Yillik bozrdagi tajriba</h1>
						</li>

						<li className='statistics__item'>
							<p className='statistics__numbers'>1k+</p>
							<h1 className='statistics__heading'>Behance dagi ko'rishlar</h1>
						</li>
					</ul>
				</div>
			</Container>
		</section>
	)
}

export default Statistics
